import type { ComponentProps, ReactNode } from "react";
import { Link } from "expo-router";
import { Pressable, StyleSheet, Text } from "react-native";

import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function AppLink({
  children,
  size = "xs",
  tone = "default",
  ...props
}: ComponentProps<typeof Link> & {
  children: ReactNode;
  size?: "xs" | "sm" | "base";
  tone?: "default" | "inverse";
}) {
  const { stylesheet, sizeStyles } = useThemedStyles(makeStyles);
  return (
    <Link accessibilityRole="link" asChild {...props}>
      <Pressable hitSlop={{ top: 12, bottom: 12, left: 4, right: 4 }}>
        {({ hovered, pressed }) => (
          <Text
            style={[
              sizeStyles[size],
              tone === "inverse" ? stylesheet.inverse : stylesheet.default,
              hovered || pressed ? stylesheet.hover : null,
            ]}
          >
            {children}
          </Text>
        )}
      </Pressable>
    </Link>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    xs: { fontFamily: fonts.regular, fontSize: 13 },
    sm: { fontFamily: fonts.regular, fontSize: 14 },
    base: { fontFamily: fonts.regular, fontSize: 16 },
    default: {
      color: colors.primary,
      textDecorationLine: "underline" as const,
    },
    inverse: { color: "#FFFFFF" },
    hover: { color: colors.heading },
  });
  const sizeStyles = {
    xs: stylesheet.xs,
    sm: stylesheet.sm,
    base: stylesheet.base,
  };
  return { stylesheet, sizeStyles };
};
